import { differenceInCalendarDays, format, isSameDay } from 'date-fns';

/** 'Today' | 'Yesterday' | weekday inside the last week | 'Sep 2, 2026'. */
export function dayDividerLabel(when: Date, today: Date): string {
  if (isSameDay(when, today)) return 'Today';
  const days = differenceInCalendarDays(today, when);
  if (days === 1) return 'Yesterday';
  if (days > 1 && days < 7) return format(when, 'EEEE');
  return format(when, 'MMM d, yyyy');
}
